import React from 'react'
import PropTypes from 'prop-types'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import FormattedMessage from '../../FormattedMessage/FormattedMessage'

const IncapsulaModal = ({ isOpen, toggle, source }) => {
  // Generate unique IDs for accessibility
  const modalId = 'incapsula-captcha-modal'
  const modalTitleId = 'incapsula-captcha-title'
  const frameId = 'incapsula-captcha-frame'

  const handleToggle = toggle || (() => {})

  return (
    <Modal
      isOpen={isOpen}
      toggle={handleToggle}
      size="lg"
      id={modalId}
      aria-labelledby={modalTitleId}
      role="dialog"
    >
      <ModalHeader toggle={handleToggle} id={modalTitleId}>
        <FormattedMessage id="global.label.incapsula" />
      </ModalHeader>
      <ModalBody style={{ height: '500px' }}>
        <iframe
          id={frameId}
          style={{ border: 'none' }}
          width="100%"
          height="100%"
          title="Incapsula Security Verification"
          src={source}
          aria-labelledby={modalTitleId}
          sandbox="allow-scripts allow-forms"
        />
        <p className="sr-only">
          <FormattedMessage
            id="global.label.captchaDescription"
            defaultMessage="This is a security verification. Please complete the challenge in the frame to continue."
          />
        </p>
      </ModalBody>
    </Modal>
  )
}

IncapsulaModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func,
  source: PropTypes.string.isRequired,
}

export default IncapsulaModal
